/**
 * WordPress dependencies
 */
import { list as icon } from '@wordpress/icons';

/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import transforms from './transforms';
import deprecated from './deprecated';

const settings = {
	icon,
	edit,
	save,
	transforms,
	deprecated,
};

export default settings;
